export const preOrderTemplate = `<div class="boost-sd__product-form boost-sd__product-form--default">
<!-- Quantity Input -->
<div class="boost-sd__product-form-quantity">
  <p id="quantity-title" class="boost-sd__product-form-quantity-title">
    {{ "quickView.qvQuantity" | translate: translations, 'Quantity' }}
  </p>
  <div class="boost-sd__input-number boost-sd__input-number--md" role="group" aria-labelledby="quantity-title">
    <div class="boost-sd__input-number-btn-wrapper">
      <button
        type="button"
        aria-label="Decrease quantity"
        aria-controls="item-quantity"
        class="boost-sd__button boost-sd__button--full-width boost-sd__input-number-btn">
        <span aria-hidden="true">-</span>
      </button>
    </div>
    <input
      id="item-quantity"
      type="number"
      aria-labelledby="quantity-title"
      aria-describedby="quantity-error"
      class="boost-sd__input-number-input"
      value="1"
      min="1" />
    <div class="boost-sd__input-number-btn-wrapper">
      <button
        type="button"
        aria-label="Increase quantity"
        aria-controls="item-quantity"
        class="boost-sd__button boost-sd__button--full-width boost-sd__input-number-btn">
        <span aria-hidden="true">+</span>
      </button>
    </div>
  </div>
  <div id="quantity-error" class="boost-sd__product-form-quantity-error" aria-live="assertive">
    {{ "quickView.qvQuantityError" | translate: translations, 'Please input quantity' }}
  </div>
</div>

<div class="boost-sd__preorder-options">
<!-- TEMPLATE PRE_ORDER WITH PAYMENT -->
{% comment %} TODO check preorder {% endcomment %}
{% if product.variants %}
  {% assign variants = product.variants %}
{% else %}
  {% assign variants = variants %}
{% endif %}

{% for variant in variants %}
  {% if variant.preorder %}
    {% assign paymentType = variant.preorder.payment.type %}
    {% assign discountType = variant.preorder.payment.discountType %}
    {% assign discountValue = variant.preorder.payment.discountValue %}
    {% assign originalPrice = variant.price %}

    {% assign paymentLabel = '' %}
    {% if paymentType == 'full' %}
      {% assign paymentLabel = 'Full payment' %}
    {% endif %}
    {% if paymentType == 'partial' %}
      {% assign paymentLabel = 'Partial payment' %}
    {% endif %}
    {% if paymentType == 'none' %}
      {% assign paymentLabel = 'No payment' %}
    {% endif %}

    {% settings assign productPrice = themeSettings.productItems.productInfo.elements.price %}
    {% capture showCurrencyCodes %}{{ settings productPrice.showCurrencyCodes }}{% endcapture %}
    {% assign moneyFormat = request.money_format | strip_html -%}
    {% if showCurrencyCodes == 'true' %}
      {% assign moneyFormat = request.money_format_with_currency | strip_html -%}
    {% endif %}
    {% assign money_rate = request.currency_rate | strip_html -%}

    {% if discountType == 'percentage' %}
      {% assign percentNum = originalPrice | times: discountValue | divided_by: 100 %}
      {% assign discountedPrice = originalPrice | times: 1.0 | minus: percentNum %}
    {% elsif discountType == 'amount' %}
      {% assign discountValue =  discountValue | times: money_rate %}
      {% assign discountedPrice = originalPrice | times: 1.0 | minus: discountValue %}
    {% else %}
      {% assign discountedPrice = originalPrice %}
    {% endif %}

    {% assign removePriceDecimal = false -%}
    {% assign showCentAsSuperscript = false -%}
    {% assign decimalDelimiter = '' -%}
    {% assign withoutTrailingZeros = true -%}

    {% assign originalPriceFormat = originalPrice | format_currency: money_format, showCentAsSuperscript, removePriceDecimal, decimalDelimiter, withoutTrailingZeros -%}
    {% assign discountedPriceFormat = discountedPrice | format_currency: money_format, showCentAsSuperscript, removePriceDecimal, decimalDelimiter, withoutTrailingZeros -%}
    {% assign discountValueFormat = discountValue | format_currency: money_format, showCentAsSuperscript, removePriceDecimal, decimalDelimiter, withoutTrailingZeros %}

    <div class="boost-sd__preorder" tabindex="0" data-variant-id="{{ variant.id }}" role="region" aria-labelledby="preorder-title" aria-describedby="preorder-description">
      <div class="boost-sd__preorder-option">
        <h2 id="preorder-title" class="boost-sd__preorder-title">{{ paymentLabel }}</h2>
        <div id="preorder-description" class="boost-sd__preorder-discount" aria-live="polite">
          {% if discountType == 'percentage' %}
            <span class="boost-sd__preorder-save">Save {{ discountValue }}%</span>
          {% elsif discountType == 'amount' %}
            <span class="boost-sd__preorder-save">Save {{ discountValueFormat }}</span>
          {% endif %}
          <div class="boost-sd__preorder-price">
            {% if discountType != 'none' %}
              <span class="boost-sd__preorder-original-price" aria-label="Original Price: {{ originalPriceFormat }}">{{ originalPriceFormat }}</span>
            {% endif %}
            <span class="boost-sd__preorder-discounted-price" aria-label="Discounted Price: {{ discountedPriceFormat }}">{{ discountedPriceFormat }}</span>
          </div>
        </div>
      </div>
    </div>
  {% endif %}
{% endfor %}

{% assign button_label = 'Pre-Order' %}

<button
  type="button"
  aria-label="{{ button_label }}"
  class="boost-sd__button boost-sd__button--border boost-sd__button--rounded boost-sd__button--large boost-sd__button--preorder">
  <span class="boost-sd__button-text" aria-hidden="true">
    {{ button_label }}
  </span>
</button>
<p tabindex="0" class="boost-sd__preorder-note">
  <strong class="boost-sd__preorder-note-title">Please note:</strong> This is a pre-order. Items will ship based on the estimated delivery date.
</p>

</div>
<div class="boost-sd__purchase-options">
  <button
    type="button"
    class="boost-sd__button boost-sd__button--border boost-sd__button--rounded boost-sd__button--large boost-sd__button--purchase">
    <span class="boost-sd__button-text">
      {{ "productItem.atcAvailableLabel" | translate: translations, 'Add to cart' }}
    </span>
  </button>

  <button
    type="button"
    class="boost-sd__button boost-sd__button--border boost-sd__button--rounded boost-sd__button--large boost-sd__btn-buy-now">
    <span class="boost-sd__button-text">{{ "quickView.buyItNowBtnLabel" | translate: translations, 'Buy it now' }}</span>
  </button>
</div>
</div>`;
